import React from 'react';
import './/StyleComponents/HomeIntroduction.css';



const HomeIntroduction = () => {

    return (

        <div>
            <div className="RealIntro">
                <p>
                    Software Developer with 2 years of experience building and maintaining production web applications,
                    with a strong focus on database-driven features.
                </p>
            </div>
        </div>
    )
}

export default HomeIntroduction;